import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export default styled(Box)(({ theme, ownerState }) => {
  const safeTheme = theme || {};

  const functions = safeTheme.functions || {};
  const borders = safeTheme.borders || {};
  const palette = safeTheme.palette || {};
  const boxShadows = safeTheme.boxShadows || {};

  const { variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow } = ownerState;

  const { linearGradient, rgba, pxToRem } = functions;
  const { borderRadius: radius = {} } = borders;
  const { transparent = {}, white = {}, gradients = {}, grey = {} } = palette;
  const { colored = [], md = "none" } = boxShadows;

  const greyColors = grey;
  const validGradients = Object.keys(gradients);
  const validColors = Object.keys((palette && palette) || {});
  const validBorderRadius = Object.keys(radius);

  const backgroundValue =
    bgColor === "transparent"
      ? transparent.main || "transparent"
      : validGradients.find((el) => el === bgColor)
      ? linearGradient
        ? linearGradient(gradients[bgColor]?.main || "#999", gradients[bgColor]?.state || "#777")
        : gradients[bgColor]?.main || "#999"
      : validColors.find((el) => el === bgColor)
      ? palette[bgColor]?.main || bgColor
      : bgColor || "transparent";

  const colorValue = validColors.find((el) => el === color)
    ? palette[color]?.main || color
    : color || "inherit";

  const borderRadiusValue = validBorderRadius.find((el) => el === borderRadius)
    ? radius[borderRadius]
    : borderRadius;

  let boxShadowValue = "none";

  if (shadow) {
    if (coloredShadow) {
      boxShadowValue = coloredShadow;
    } else if (shadow === "inherit") {
      boxShadowValue = "inherit";
    } else if (boxShadows[shadow]) {
      boxShadowValue = boxShadows[shadow];
    } else {
      boxShadowValue = md;
    }
  }

  return {
    opacity,
    background: backgroundValue,
    color: colorValue,
    borderRadius:
      pxToRem && typeof borderRadiusValue === "number"
        ? pxToRem(borderRadiusValue)
        : borderRadiusValue,
    boxShadow: boxShadowValue,
  };
});
